import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProtectedAdminRoute({ children }: { children: JSX.Element }) {
  const { user } = useAuth();

  // Nur diesen Nutzer erlauben
  const isAdmin = user?.email === 'dennishorn@gmx.net';

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
